import dayjs from 'dayjs';
import { RootState } from 'types';
import { initialState, validNonRenewableSubscriptions } from '.';

export const selectCurrentUser = (state: RootState) => {
  return state?.users?.currentUser || initialState.currentUser;
};
export const selectCurrentUserId = (state: RootState) => {
  return state?.users?.currentUser?.id || undefined;
};
export const selectCurrentUserSubscription = (state: RootState) => {
  return state?.users?.currentUserSubscription || undefined;
};
export const selectNonRenewingSubscriptionExpiryDate = (state: RootState) => {
  const allPurchaseDates = state?.users?.currentUserSubscription?.allPurchaseDates;

  const startDates = validNonRenewableSubscriptions(allPurchaseDates);

  if (startDates.length === 0) return undefined;

  return startDates[0].add(1, 'week');
};

export const selectHasAccessWithLicenseCode = (state: RootState) => {
  const hasLicenseCode = !!state?.users?.currentUser?.license_code;
  const hasLicenseExpired =
    state?.users?.currentUser?.license_code_expiry_date &&
    dayjs(state?.users?.currentUser?.license_code_expiry_date).isBefore(dayjs());
  return hasLicenseCode && !hasLicenseExpired;
};

export const selectHasBackendConfirmedAccess = (state: RootState) => {
  const accessTier = state?.users?.currentUser?.access_tier;
  return !!accessTier && accessTier !== 'FREE';
};

export const selectDoesUserHaveFullAccess = (state: RootState) => {
  const hasValidNonRenewableSubscription = !!selectNonRenewingSubscriptionExpiryDate(state);

  // The RevenueCat SDK checks stay in as an OR, never as a replacement: between
  // a purchase completing on the device and the webhook reaching us they are the
  // only thing that knows about it, so they can still *grant* access early. What
  // they can no longer do is take it away when the SDK has told us nothing yet.
  return (
    selectHasBackendConfirmedAccess(state) ||
    (state?.users?.currentUserSubscription?.activeSubscriptions?.length || 0) > 0 ||
    selectHasAccessWithLicenseCode(state) ||
    hasValidNonRenewableSubscription ||
    !!state?.users?.currentUser?.is_caregiver
  );
};
